// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/incorrectIcon.svg"
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialCost from "../images/Social-cost.svg"
import DemandIcon from "../images/Demand.svg"
import { styled } from "@material-ui/core/styles";
import LabelsFor4 from "./LabelsFor4";
import { Grid, Typography } from "@material-ui/core";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";

var _ = require('lodash');

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
// var CanvasJS = CanvasJSReact.CanvasJS;

const BubbleAndLine4 = (props) => {
  const [answerCoordinates, setAnswerCoordinates] =useState([{style: {}, XYPoint: {}}])
  const [allCorrect, setAllCorrect] =useState(false)
  const [xLabel, setXLabel] =useState("")
  const [yLabel, setYLabel] =useState("")
  const { qIndex, handleReloadClick, classes } = props;
  const [chartData, setChartData] =useState([])
  const [bubbleData, setBubbleData] =useState([])
  const [bubbleColor, setBubbleColor] =useState('#8C479B')
  const [submit, setSubmit] =useState(false)
  const [isYes, setIsYes] = useState(null)
  const [reRender, setReRender] = useState(false)
  const [buyAmount, setBuyAmount] = useState("");
  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [buyerTax, setBuyerTax] = useState(0)
  const [sellerTax, setSellerTax] = useState(0)
  const [socialCost, setSocialCost] = useState(0)

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "spline",
      color: bubbleColor,
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 16, cursor: 'pointer', z: 3}, {x: 50, y: 20, cursor: 'pointer', z: 3}, {x: 150, y: 30, cursor: 'pointer', z: 3}, {x: 250, y: 40, cursor: 'pointer', z: 3}, {x: 290, y: 44, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 6, cursor: 'pointer', z: 1}, {x: 50, y: 10, cursor: 'pointer', z: 1}, {x: 150, y: 20, cursor: 'pointer', z: 1}, {x: 250, y: 30, cursor: 'pointer', z: 1}, {x: 290, y: 34, cursor: 'pointer', z: 1}]
    },
    {
      type: "spline",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 34, cursor: 'pointer'}, {x: 100, y: 25, cursor: 'pointer'}, {x: 200, y: 15, cursor: 'pointer'}, {x: 250, y: 10, cursor: 'pointer'}, {x: 290, y: 6, cursor: 'pointer'}]
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 15,
      color: 'green',
      dataPoints: []
    },
    {
      type: "line",
      lineThickness: isMobile ? 3 : 5,
      lineDashType: "shortDash",
      color: 'green',
      dataPoints: []
    },
    {
      type: "line",
      lineThickness: isMobile ? 3 : 5,
      lineDashType: "shortDash",
      color: 'green',
      dataPoints: []
    },
    // {
    //   type: "scatter",
    //   markerSize: 15,
    //   color: 'green',
    //   dataPoints: []
    // },
  ]


  // window.addEventListener("resize", () => setTimeout(() => {
  //   setReRender(!reRender)
  //   setCanvasWidth(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
  //   return window.removeEventListener("resize", () => {
  //   })
  // }, 50));

  useEffect(() => {
    setChartData(data)
    // console.log(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
    // setCanvasWidth(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
  }, [])

  useEffect(() => {
    if(submit === true){
      setAllCorrect(buyerTax === 150 && sellerTax === 100 )
      if(buyerTax === 150 && sellerTax === 100){
        data[4].dataPoints = [{x: 100, y: 25, cursor: 'pointer', z: 3}, {x: 150, y: 20, cursor: 'pointer', z: 3}]
        data[5].dataPoints = [{x: 100, y: 25, z: 3}, {x: 100, y: 0, z: 3}]
        data[6].dataPoints = [{x: 150, y: 20, z: 3}, {x: 150, y: 0, z: 3}]
        // data[6].dataPoints = [{x: 0, y: 20, z: 3}, {x: 150, y: 20, z: 3}]
        // data[5].dataPoints = [{x: 150, y: 20, cursor: 'pointer', z: 3}]
        setChartData(data)
      }
    }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setBuyerTax(0)
    setSocialCost(0)
    setIsYes(0)
    setSellerTax(0)
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  return (
      <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer4}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
           <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "flex-start" }}>
            <h3 className={classes.titleText4}>{questionsAnswers[qIndex].question}</h3>
            <div className={`animate__animated animate__bounceIn ${classes.questionContainer4}`}>
              <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "start", paddingLeft: "1%" }} className="animate__animated animate__bounceIn">
                <p className={classes.question1Text4}>What is the quantity produced at the market equilibrium (Q<sub>m</sub>)?</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={classes.incrementButton3} disabled={buyerTax === 0 || submit} onClick={() => setBuyerTax(buyerTax-10)}><b>-</b></button>
                  <p className={classes.valueText3} style={{ color: submit ? buyerTax === 150 ? "green" : "red" : "#043e4b" }}>{buyerTax}</p>
                  <button className={classes.incrementButton3} disabled={submit} onClick={() => setBuyerTax(buyerTax+10)}><b>+</b></button>
                </div>

                <p className={classes.question2Text4}>What is the quantity produced at the socially optimal equilibrium (Q<sub>e</sub>)?</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={classes.incrementButton3} disabled={sellerTax === 0 || submit} onClick={() => setSellerTax(sellerTax-10)}><b>-</b></button>
                  <p className={classes.valueText3} style={{ color: submit ? sellerTax === 100 ? "green" : "red" : "#043e4b" }}>{sellerTax}</p>
                  <button className={classes.incrementButton3} disabled={submit} onClick={() => setSellerTax(sellerTax+10)}><b>+</b></button>
                </div>
              </div>
            </div>

            {submit && 
            <div className={classes.answerTextContainer}>
              {!allCorrect ?
                <div className={classes.incorrectAnswerContainer}>
                  <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon}/>
                </div>
              :
              <Grid container className={classes.correctAnswerContainer}>
                <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon} />
                <Typography className={classes.answerText}>
                  The market equilibrium is where supply and demand intersect. The socially optimal equilibrium is where social cost and demand intersect.
                </Typography>
              </Grid>
              }
            </div>
            }
           </div>
          </div>
        </div>
        {/* <Grid style={{position: "relative" }}>
          { allCorrect && submit &&
            <LabelsFor4 canwidth={canvasWidth}/>
          }
        </Grid> */}
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
          <DropableLabel
            right={isMobile ? '-24%' : "-20%"}
            marginTop={isMobile ? "12%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>

          <img src={SocialCost} alt="" className={classes.socialCostIcon3} />
          <img src={supplyIcon} alt="" className={classes.supplyIcon3} />
          <img src={DemandIcon} alt="" className={classes.demandIcon3}/>
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <DropableLabel
            right={isMobile ? "70%": "75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />
          {/* <img src={DemandIcon} alt="" className={classes.demandIcon3}/> */}
          {/* <img src={DemandIcon} alt="" style={{ height: 80, width: 80, position: "absolute", zIndex: 10, right: "-12%", top: 380 }}/> */}
          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
          
          <div className={classes.buttonContainer}>
            {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.submitButtom} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.submitButtom} style={{color: "#00b1d9", marginLeft: 20, backgroundColor: '#fff' }} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.submitButtomNext}  style={{ marginLeft: "10%" }} onClick={() => handleReloadClick()}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine4);
